export const TKeySettings = {
  SETTINGS: "SETTINGS",
  SETTINGS_EXTENSION_TOKEN: "SETTINGS_EXTENSION_TOKEN",
  SETTINGS_EXTENSION_TOKEN_DESCRIPTION: "SETTINGS_EXTENSION_TOKEN_DESCRIPTION",
  SETTINGS_LANGUAGE: "SETTINGS_LANGUAGE",
  SETTINGS_EXTENSION_TOKEN_GENERATE: "SETTINGS_EXTENSION_TOKEN_GENERATE",
  SETTINGS_EXTENSION_TOKEN_REGENERATE: "SETTINGS_EXTENSION_TOKEN_REGENERATE",
  SETTINGS_EXTENSION_TOKEN_REVOKE: "SETTINGS_EXTENSION_TOKEN_REVOKE",
  SETTINGS_MCP_CONNECTOR: "SETTINGS_MCP_CONNECTOR",
  SETTINGS_MCP_CONNECTOR_DESCRIPTION: "SETTINGS_MCP_CONNECTOR_DESCRIPTION",
  SETTINGS_MCP_MODE_CONNECTOR: "SETTINGS_MCP_MODE_CONNECTOR",
  SETTINGS_MCP_MODE_TOKEN: "SETTINGS_MCP_MODE_TOKEN",
  SETTINGS_MCP_TOKEN_DESCRIPTION: "SETTINGS_MCP_TOKEN_DESCRIPTION",
  SETTINGS_MCP_TOKEN_GENERATE: "SETTINGS_MCP_TOKEN_GENERATE",
  SETTINGS_MCP_TOKEN_REGENERATE: "SETTINGS_MCP_TOKEN_REGENERATE",
  SETTINGS_MCP_TOKEN_REVOKE: "SETTINGS_MCP_TOKEN_REVOKE",
  SETTINGS_MCP_TOKEN_GUIDE_LINK: "SETTINGS_MCP_TOKEN_GUIDE_LINK",
  SETTINGS_EXTENSION_TOKEN_GUIDE_LINK: "SETTINGS_EXTENSION_TOKEN_GUIDE_LINK",
  SETTINGS_PROFILE: "SETTINGS_PROFILE",
  SETTINGS_ACCOUNT: "SETTINGS_ACCOUNT",
  SETTINGS_SAVE: "SETTINGS_SAVE",
  SETTINGS_SAVED: "SETTINGS_SAVED",
  SETTINGS_EMAIL_SENT: "SETTINGS_EMAIL_SENT",
  SETTINGS_CHANGE_PASSWORD: "SETTINGS_CHANGE_PASSWORD",
  SETTINGS_DELETE_ACCOUNT: "SETTINGS_DELETE_ACCOUNT",
  SETTINGS_DELETE_ACCOUNT_TEXT: "SETTINGS_DELETE_ACCOUNT_TEXT",
  SETTINGS_DELETE_ACCOUNT_SUCCESS: "SETTINGS_DELETE_ACCOUNT_SUCCESS",
  AVATAR: "AVATAR",
  SETTINGS_CONFIRM_EMAIL_CHANGE: "SETTINGS_CONFIRM_EMAIL_CHANGE",
  CHANGE_EMAIL_DESCRIPTION: "CHANGE_EMAIL_DESCRIPTION",
  CHANGE_EMAIL_SUCCESS: "CHANGE_EMAIL_SUCCESS",
} as const;
